import { Component, EventEmitter, inject, Input, Output, SimpleChanges } from '@angular/core';
import { ToasterComponent } from "../../../shared/Componet/toaster/toaster.component";
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MembershipService } from '../memberships/Services/Membership.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-upload-bills',
  imports: [ToasterComponent, ReactiveFormsModule, TranslateModule, CommonModule],
  templateUrl: './upload-bills.component.html',
  styleUrl: './upload-bills.component.css'
})
export class UploadBillsComponent {

  AttachmentsForm!: FormGroup;
  attachments: File[] = [];
  previewUrls: (string | ArrayBuffer)[] = [];
  showToast = false;
  toastMessage = '';
  toastType: 'success' | 'error' = 'success';
  showMembershipModal: boolean = false;
  @Input() membershipId!: number
  @Input() membershipData: any;
  @Output() membershipDataUpdated = new EventEmitter<void>();
  @Output() getMembershipByUserId = new EventEmitter<void>();

  private fb = inject(FormBuilder);
  private MembershipService = inject(MembershipService)
  private translate = inject(TranslateService)

  ngOnInit(): void {
    this.AttachmentsForm = this.fb.group({
      note: ['']
    });
  }

  // ngAfterViewInit() {
  //   this.membershipId = +localStorage.getItem("membershipId")!

  // }

  ngOnChanges(changes: SimpleChanges) {
    // console.log("this.membershipId", this.membershipId)
    if (changes['membershipData'] && this.membershipData) {
      // console.log("Updated membershipData:", this.membershipData);
      this.previewUrls = [...this.membershipData.attachments.map((att: any) => att.path)];
    }
    // console.log("membershipId",this.membershipId)
  }

  onFilesSelected(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.attachments = Array.from(files);
      // this.previewUrls = []; // reset previous previews

      Array.from(files).forEach(file => {
        const reader = new FileReader();
        reader.onload = () => {
          this.previewUrls.push(reader.result!); // اضيف النتيجة للمصفوفة
        };
        reader.readAsDataURL(file as File);  // ← أكدنا أن file من نوع File
      });

    }

    // console.log("Selected attachments:", this.attachments);
  }

  onAttachementSubmit() {
    const formData = new FormData();

    // اضافة الملفات
    this.attachments.forEach(file => {
      formData.append("Attachments", file);
    });

    // اضافة id و note
    formData.append('id', this.membershipId?.toString() || '');
    formData.append('note', this.AttachmentsForm.get('note')?.value || '');

    // رفع الملفات
    this.MembershipService.AddAttachment(formData).subscribe({
      next: (response: any) => {
        // console.log("Uploaded!", response);
        if (response.succeeded) {
          this.closeMembershipModal()
          // console.log("succeeded");
          this.toastType = 'success';
          this.toastMessage = this.translate.instant('MEMBERSHIP.SUCESSFULLY_SUBMITTED_ATTACHMENT');
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
          this.membershipDataUpdated.emit();
          this.getMembershipByUserId.emit();
        }
        else {
          this.closeMembershipModal()
          this.toastType = 'error';
          this.toastMessage = response.errors[0];
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
        }
      },
      error: (err: any) => {
        // console.log("Upload error", err);
      }
    });
  }


  closeMembershipModal() {
    this.showMembershipModal = false;

    // خزّن إنه قفل المودال
    localStorage.setItem('membershipModalClosed', 'true');

    // إزالة الباك دروب لو لسه موجود
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove();
  }

}
